const cta = 'data-cta-delay';
const ctaElement = document.querySelector(`[${cta}]`);
if (ctaElement) {
  const documentHeight = document.documentElement.scrollHeight;
  const ctaDelay = parseInt(ctaElement?.getAttribute(cta));

  const showCta = () => {
    ctaElement.classList.add('show');
  }

  if (ctaDelay <= 0) {
    showCta()
  } else {
    window.addEventListener('scroll', () => {
      if ((100 * window.scrollY) / documentHeight >= ctaDelay) {
        showCta()
      } else {
        ctaElement.classList.remove('show');
      }
    })
  }
}
